import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { partnerNativeLocationEditSchema, partnerProfessionDetailEditSchema } from '../../../ValidationSchema';
import { editPartnerNativeLocation, editPartnerprofessionalPreference, getAllIncome, getCity, getCountry, getEducation, getMultipleCity, getMultipleState, getOccupation, getState } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Card, CardContent, CardHeader, MenuItem, TextField, Button, FormControl, InputLabel, Select, Chip, Autocomplete } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const PartnerNativeDetailEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const userProfileData = location.state?.userProfileData || {};
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

    const handleClosePopup = () => {
        setPopupData({ ...popupData, open: false });
    };

    useEffect(() => {
        if (popupData.open) {
            const timer = setTimeout(() => {
                setPopupData(prev => ({ ...prev, open: false }));
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [popupData.open]);

    const nativeCountryArray = userProfileData.partnerCountry
        ? userProfileData.partnerCountry.split(',').map((item) => item.trim())
        : [];

    const nativeStateArray = userProfileData.partnerState
        ? userProfileData.partnerState.split(',').map((item) => item.trim())
        : [];

    const nativeCityArray = userProfileData.partnerCity
        ? userProfileData.partnerCity.split(',').map((item) => item.trim())
        : [];
    const nativeCitizenshipArray = userProfileData.partnerCitizenship
        ? userProfileData.partnerCitizenship.split(',').map((item) => item.trim())
        : [];

    const formik = useFormik({
        initialValues: {
            partnerCountry: nativeCountryArray,
            partnerState: nativeStateArray,
            partnerCity: nativeCityArray,
            partnerCitizenship: nativeCitizenshipArray,
            // tokan: localStorage.getItem('token')
        },
        validationSchema: partnerNativeLocationEditSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const formattedValues = {
                    ...values,
                    partnerCountry: values.partnerCountry.join(','),
                    partnerState: values.partnerState.join(','),
                    partnerCity: values.partnerCity.join(','),
                    partnerCitizenship: values.partnerCitizenship.join(','),
                };
                const response = await editPartnerNativeLocation(formattedValues);
                if (response.status === 200 || response.status === 201) {
                    setPopupData({ open: true, type: 'success', message: 'Successfully updated the Partner Education & Profession data' });
                    setTimeout(() => {
                        navigate(-1);
                    }, 3000);
                } else {
                    setPopupData({ open: true, type: 'error', message: 'Failed to update the Partner Education & Profession data' });
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: 'Failed to update the Partner Education & Profession data' });
            } finally {
                setSubmitting(false);
            }
        }
    });
    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await getCountry();
                if (response.status === 200 || response.status === 201) {
                    setCountries(response.data.data);
                }
            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
            }
        };
        fetchCountry();
    }, []);

    useEffect(() => {
        const fetchState = async () => {
            if (formik.values.partnerCountry.length > 0) {
                try {
                    const response = await getMultipleState({ ids: formik.values.partnerCountry });
                    if (response.status === 200 || response.status === 201) {
                        setStates(response.data);
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };
        fetchState();
    }, [formik.values.partnerCountry]);

    useEffect(() => {
        const fetchCity = async () => {
            if (formik.values.partnerState.length > 0) {
                try {
                    const response = await getMultipleCity({ ids: formik.values.partnerState });
                    if (response.status === 200 || response.status === 201) {
                        setCities(response.data);
                    }
                } catch (error) {
                    setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
                }
            }
        };
        fetchCity();
    }, [formik.values.partnerState]);
    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={<ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
                    title="Partner's Native Locationn"
                    subheader="Update your partner's native location details to find suitable matches"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={countries}
                                    getOptionLabel={(option) => option.country}
                                    value={countries.filter(rel => formik.values.partnerCountry.includes(String(rel.id)))}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue('partnerCountry', newValue.map(item => String(item.id)));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Native Country"
                                            variant="outlined"
                                            className='mb-3'
                                            error={formik.touched.partnerCountry && Boolean(formik.errors.partnerCountry)}
                                            helperText={formik.touched.partnerCountry && formik.errors.partnerCountry}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option?.country || ''} // Safeguard against undefined option
                                                onDelete={() =>
                                                    formik.setFieldValue('partnerCountry', formik.values.partnerCountry.filter(id => id !== String(option.id)))
                                                }
                                                {...getTagProps({ index })}
                                                key={option.id}
                                            />
                                        ))
                                    }
                                />
                            </div>

                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={states}
                                    getOptionLabel={(option) => option.state_name}
                                    value={states.filter(rel => formik.values.partnerState.includes(String(rel.state_id)))}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue('partnerState', newValue.map(item => String(item.state_id)));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Native State"
                                            variant="outlined"
                                            className='mb-3'
                                            error={formik.touched.partnerState && Boolean(formik.errors.partnerState)}
                                            helperText={formik.touched.partnerState && formik.errors.partnerState}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option.state_name}
                                                onDelete={() => formik.setFieldValue('partnerState', formik.values.partnerState.filter(id => id !== String(option.state_id)))}
                                                {...getTagProps({ index })}
                                                key={option.state_id}
                                            />
                                        ))
                                    }
                                />
                            </div>

                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={cities}
                                    getOptionLabel={(option) => option.city}
                                    value={cities.filter(caste => formik.values.partnerCity.includes(String(caste.id)))}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue('partnerCity', newValue.map(item => String(item.id)));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Native City"
                                            variant="outlined"
                                            className='mb-3'
                                            error={formik.touched.partnerCity && Boolean(formik.errors.partnerCity)}
                                            helperText={formik.touched.partnerCity && formik.errors.partnerCity}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option.city}
                                                onDelete={() => formik.setFieldValue('partnerCity', formik.values.partnerCity.filter(id => id !== String(option.id)))}
                                                {...getTagProps({ index })}
                                                key={option.id}
                                            />
                                        ))
                                    }
                                />
                            </div>
                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={countries}
                                    getOptionLabel={(option) => option.country}
                                    value={countries.filter(rel => formik.values.partnerCitizenship.includes(String(rel.id)))}
                                    onChange={(event, newValue) => {
                                        formik.setFieldValue('partnerCitizenship', newValue.map(item => String(item.id)));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Native Citizenship"
                                            variant="outlined"
                                            className='mb-3'
                                            error={formik.touched.partnerCitizenship && Boolean(formik.errors.partnerCitizenship)}
                                            helperText={formik.touched.partnerCitizenship && formik.errors.partnerCitizenship}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option?.country || ''} // Safeguard against undefined option
                                                onDelete={() =>
                                                    formik.setFieldValue('partnerCitizenship', formik.values.partnerCitizenship.filter(id => id !== String(option.id)))
                                                }
                                                {...getTagProps({ index })}
                                                key={option.id}
                                            />
                                        ))
                                    }
                                />
                            </div>
                        </div>
                        {/* <div className="d-grid col-4 mx-auto mt-2"> */}
                        <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                            {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
                        </Button>
                        {/* </div> */}
                    </form>
                </CardContent>
            </Card>
            <Popup
                open={popupData.open}
                type={popupData.type}
                message={popupData.message}
                onClose={handleClosePopup}
            />
        </div>
    );
}
